import {createApi} from "@reduxjs/toolkit/query/react";
import axios from "axios";

const api = axios.create({
    baseURL: process.env.REACT_APP_API_SERVER_URL,
    headers: {
        "Content-Type": "application/json",
    },
});

export const multiplayerSlice = createApi({
    baseQuery: async ({url, method, body, headers}) => {
        try {
            const response = await api({
                url,
                method,
                headers,
                data: body,
            });
            return {data: response.data};
        } catch (error) {
            return {
                error: {status: error.response?.status, data: error.response?.data || error.message},
            };
        }
    },
    endpoints: (builder) => ({
        registerPlayWithStranger: builder.mutation({
            queryFn: async (data) => {
                try {
                    const response = await api.post(
                        `/game/${data.uuid}/multiplayer/play-with-strangers`,
                        {
                            "Name": data.name,
                            "Avatar": data.avatar,
                        },
                        {
                            headers: {
                                "User-ID": data.user_id,
                                "Client-Id": process.env.REACT_APP_CLIENT_ID,
                                "platform-name": "WEB",
                                "build-number": 1
                            },
                        }
                    );
                    return {data: response.data};
                } catch (error) {
                    return {
                        error: {status: error.response?.status, data: error.response?.data || error.message},
                    };
                }
            },
        }),
    }),
});

export const {
    useRegisterPlayWithStrangerMutation,
} = multiplayerSlice;
